import React, { createContext, useEffect, useState } from "react";
import PropTypes from "prop-types";
// eslint-disable-next-line import/no-duplicates
// eslint-disable-next-line import/no-duplicates
import { Alert } from "antd";

import ChartContainer from "./ChartContainer";
import GeneratdBuilder from "./GeneratedBuilder";

const CubeJsQueryRenderer = createContext({});

export const ChartRenderer = (props) => {
  const [jsCompilingError, setError] = useState(null);
  const [chartLibrary, setChartLibrary] = useState("bizcharts");

  const {
    query,
    resultSet,
    error,
    sqlQuery,
    dashboardSource,
    cubejsApi,
    chartType,
    pivotConfig,
  } = props;

  useEffect(() => {
    if (jsCompilingError) {
      setError(null);
    }
  }, [chartType, jsCompilingError]);

  return (
    <CubeJsQueryRenderer.Provider
      value={{
        query,
        pivotConfig,
      }}
    >
      <ChartContainer
        query={query}
        resultSet={resultSet}
        error={error}
        sqlQuery={sqlQuery}
        dashboardSource={dashboardSource}
        chartLibrary={chartLibrary}
        setChartLibrary={setChartLibrary}
        cubejsApi={cubejsApi}
        hideActions={true}
        render={() => {
          if (jsCompilingError) {
            return (
              <Alert
                message="Error occurred while compiling JS"
                description={<pre>{jsCompilingError.toString()}</pre>}
                type="error"
              />
            );
          }
          return (
            <GeneratdBuilder
              query={query}
              cubejsApi={cubejsApi}
              pivotConfig={pivotConfig}
              chartType={chartType}
            />
          );
        }}
      />
    </CubeJsQueryRenderer.Provider>
  );
};

ChartRenderer.propTypes = {
  query: PropTypes.object.isRequired,
  resultSet: PropTypes.object,
  error: PropTypes.object,
  sqlQuery: PropTypes.object,
  dashboardSource: PropTypes.object,
  cubejsApi: PropTypes.object,
  chartType: PropTypes.string,
  sourceCodeFn: PropTypes.func,
};

ChartRenderer.defaultProps = {
  resultSet: null,
  error: null,
  sqlQuery: null,
  dashboardSource: null,
  cubejsApi: null,
  chartType: null,
  sourceCodeFn: null,
};
